import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';
import LightMode from '@mui/icons-material/LightMode';
import DarkMode from '@mui/icons-material/DarkMode';
import { schibstedLightTheme, schibstedDarkTheme } from '../themes/schibsted';

export const schibstedLightThemeExtension = ThemeBlueprint.make({
  name: 'schibsted-light',
  params: {
    theme: {
      id: 'schibsted-light',
      title: 'Light',
      variant: 'light',
      icon: <LightMode />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={schibstedLightTheme} children={children} />
      ),
    },
  },
});

export const schibstedDarkThemeExtension = ThemeBlueprint.make({
  name: 'schibsted-dark',
  params: {
    theme: {
      id: 'schibsted-dark',
      title: 'Dark',
      variant: 'dark',
      icon: <DarkMode />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={schibstedDarkTheme} children={children} />
      ),
    },
  },
});
